import usePartsAIEventHandlers from "./usePartsAIEventHandlers";
import { useOwnChatStream } from "src/reusable/Chat/ChatStreaming/hooks/useOwnChatStream";
import { nuclearn_api_url } from "src/App";
import { ChatConfiguration } from "src/reusable/Chat/ChatStreaming/types";

export const usePartsAIChat = (
  config?: Partial<ChatConfiguration>,
  dialogue?: any[],
) => {
  const { metadataHandler, messageHandler } = usePartsAIEventHandlers();

  const streamingResult = useOwnChatStream(
    {
      // Agentic streaming pipeline (same as AtomAssist / Proposal Generation).
      api: `${nuclearn_api_url}/chat/start`,
      onMetadataEvent: metadataHandler,
      onMessageEvent: messageHandler,
      ...config,
    },
    dialogue,
  );

  return streamingResult;
};
